<template>
  <!-- max-w-7xl -->
  <!-- :style="{ 'background-color': settings.colors.primaryColor }" -->
  <Disclosure
    v-if="settings"
    as="nav"
    class="store-nav sticky inset-x-0 top-0 left-0 z-50 w-full py-2 bg-white border-b border-gray-200 md:py-0"
  >
  
    <div class="store-nav-inner container mx-auto max-w-7xl">
      <div class="store-top-row">
        <div class="store-brand flex items-center flex-shrink-0">
          <a href="/" class="flex items-center">
            <img v-if="settings.strings.website.websiteHeaderImage" v-bind:src="settings.strings.website.websiteHeaderImage" class="h-6 mr-3 sm:h-9" alt="TUBO Logo" />
            <span class="store-brand-name self-center text-xl font-semibold whitespace-nowrap">{{
              settings.strings.app_name
            }}</span>
          </a>
        </div>
        <div v-if="false" class="flex items-center justify-center">
          <div
            class="content-center hidden px-5 py-3 rounded-md sm:block sm:ml-6"
          >
            <div
              class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
              id="navbar-sticky"
            >
              <div
                class="flex flex-row p-2 mt-4 rounded-lg md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium"
                v-for="vendor in vendors"
                :key="vendor.id"
              >
                <a
                  :href="
                    $router.resolve({
                      name: 'VendorHome',
                      params: {
                        id: vendor.id,
                        slug: sanitizeTitle(`${vendor.slug}`),
                      },
                    }).href
                  "
                  class="block py-2 pl-3 pr-4 text-gray-700 rounded hover:text-gray-300 md:bg-transparent md:p-0"
                  aria-current="page"
                >
                  {{ vendor.name }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="store-location">
          <span class="store-location-caption">Delivering to</span>
          <button type="button" class="store-location-button" @click="locationOpen = !locationOpen">
            <MapPinIcon class="store-outline-icon" aria-hidden="true" />
            <span>{{ locationLabel }}</span>
            <span class="store-location-chevron" aria-hidden="true"></span>
          </button>
          <div class="store-location-popover" v-if="locationOpen">
            <p>Choose a delivery location</p>
            <GMapAutocomplete
              class="store-location-input"
              placeholder="Search your area or address"
              @place_changed="setLocation"
            />
          </div>
        </div>
        <form class="store-search flex items-center justify-between p-1 my-2 border" @submit.prevent="getSearchResult">
          <MagnifyingGlassIcon class="store-search-leading" aria-hidden="true" />
            <input
              class="store-search-input w-full p-2 border-none rounded-full placeholder:font-light placeholder:text-sm"
              v-model="search"
              type="search"
              placeholder="Search products and shops"
            />
            <button
              type="submit"
              aria-label="Search"
              class="store-search-button flex items-center p-2 rounded-full cursor-pointer"
            >
              Search
            </button>
        </form>
        <div class="store-actions flex items-center">
          <!-- <span class=""> -->
          <!-- <img :src="`/img/en.png`" class="w-8 h-8"> -->
          <!-- <select v-model="$i18n.locale" class="px-3 py-2 -m-2 text-black bg-gray-100 rounded-full md:mx-2">
                  <option v-for="(lang, i) in $i18n.availableLocales" class="bg-transparent " :key="`Lang${i}`" :value="lang">
                    
                    <span>{{ lang }}</span>
                  </option>
                </select>
                </span> -->

          <button
            class="store-icon-button p-2 bg-white rounded-full"
            v-on:click="toggleModal()"
            type="button"
            v-show="isLoggedIn == false"
          >
            <UserCircleIcon class="store-outline-icon" aria-hidden="true" />
          </button>

          <!-- Profile dropdown -->
          <Menu as="div" class="relative p-2" v-show="isLoggedIn">
            <div class="flex space-x-2">
              <MenuButton
                class="flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-black"
              >
                <span class="sr-only">Open user menu</span>
                <img
                  class="w-6 h-6 rounded-full"
                  v-if="user"
                  v-bind:src="user.photo"
                  alt="user photo"
                />
              </MenuButton>
            </div>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <MenuItems
                class="absolute right-0 w-48 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
              >
                <MenuItem v-slot="{ active }">
                  <a
                    href="/profile"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-black',
                    ]"
                    >My Profile</a
                  >
                </MenuItem>
                <MenuItem v-slot="{ active }">
                  <a
                    href="/favourites"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-black',
                    ]"
                    >My Favourites</a
                  >
                </MenuItem>
                <!-- <MenuItem v-slot="{ active }">
                <a href="/orders"
                  :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-black']">Orders</a>
                  </MenuItem> -->
                <!-- <MenuItem v-slot="{ active }">
                      <a href="/wallet" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-black']">Wallet</a>
                      </MenuItem> -->
                <MenuItem v-slot="{ active }">
                  <a
                    href="#"
                    @click="logout"
                    :class="[
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-black',
                    ]"
                    >Sign out</a
                  >
                </MenuItem>
              </MenuItems>
            </transition>
          </Menu>
          <a href="/cart" class="store-cart-link flex mx-2 bg-white rounded-full">
            <span class="hidden md:flex">
              <CartPopover />
            </span>
            <span class="flex md:hidden">
              <ShoppingBagIcon class="store-outline-icon" aria-hidden="true" />
              <span class="text-xs text-gray-500">{{ cartItemCount }}</span>
            </span>
          </a>

          <!-- </span> -->
        </div>
      </div>
      <nav class="store-category-nav" aria-label="Shop departments">
        <router-link to="/" class="store-category-link" :class="{ 'is-active': $route.name === 'home' }">
          <Squares2X2Icon class="store-category-all-icon" aria-hidden="true" />
          <span>All</span>
        </router-link>
        <router-link
          v-for="vendor in vendors"
          :key="vendor.id"
          :to="{ name: 'VendorHome', params: { id: vendor.id, slug: sanitizeTitle(vendor.name || vendor.slug) } }"
          class="store-category-link"
          :class="{ 'is-active': $route.params.id == vendor.id }"
        >
          <BuildingStorefrontIcon class="store-category-icon" aria-hidden="true" />
          <span>{{ vendor.name }}</span>
        </router-link>
      </nav>
      <DisclosurePanel class="sm:hidden">
        <div class="px-1 pt-2 pb-3 space-y-1">
          <a
            v-for="item in navigation"
            :key="item.name"
            :href="item.href"
            :class="[
              item.current
                ? 'text-sm text-green-500'
                : 'text-primary hover:text-black',
              'block px-3 text-sm py-2 rounded-md font-medium',
            ]"
            :aria-current="item.current ? 'page' : undefined"
            >{{ item.name }}</a
          >
        </div>
      </DisclosurePanel>
    </div>
  </Disclosure>
  <div
    v-if="showModal"
    class="store-login-overlay fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
  >
    <div class="relative w-full h-full p-4 md:w-5/12 md:h-auto">
      <!-- Modal content -->
      <div class="store-login-dialog relative bg-white rounded-lg shadow">
        <button
          type="button"
          class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
          v-on:click="toggleModal()"
          data-modal-toggle="authentication-modal"
        >
          <svg
            aria-hidden="true"
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <div class="px-6 py-6 lg:px-8">
          <h3 class="mb-4 text-xl font-medium text-gray-900">
            {{ $t("login.welcome") }}
          </h3>
          <form class="space-y-6" action="#">
            <div>
              <label for="email" class="text-sm font-light text-gray-500 x-5">{{
                $t("login.email")
              }}</label>
              <input
                type="email"
                v-model="details.email"
                id="email"
                class="block w-full h-12 px-3 py-3 mt-1 border border-gray-200 rounded-lg bg-gray-50 placeholder:font-light sm:text-sm"
                placeholder="name@company.com"
                required
              />
              <p class="text-sm text-red-500">{{ message }}</p>
            </div>
            <div>
              <label
                for="password"
                class="text-sm font-light text-gray-500 x-5"
                >{{ $t("login.password") }}</label
              >
              <input
                type="password"
                v-model="details.password"
                id="password"
                placeholder="••••••••"
                class="block w-full h-12 px-3 py-3 mt-1 border border-gray-200 rounded-lg bg-gray-50 placeholder:font-light sm:text-sm"
                required
              />
              <p class="text-sm text-red-500">{{ message }}</p>
            </div>
            <div class="flex justify-between">
              <!-- <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input id="remember" type="checkbox" value="" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-600 dark:border-gray-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800" required>
                            </div>
                            <label for="remember" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Remember me</label>
                          </div> -->
              <!-- <a href="#" class="text-sm text-gray-500 hover:underline">Lost Password?</a> -->
            </div>
            <button
              type="button"
              @click="login"
              class="flex items-center justify-center w-full p-2 mt-5 font-light text-white bg-blue-800 rounded-full cursor-pointer h-14"
            >
              {{ $t("nav.login") }}
            </button>
            <div class="text-sm font-medium text-gray-500">
              {{ $t("login.dontHaveAnAccount") }}
              <a href="/register" class="text-blue-700 hover:underline">
                {{ $t("login.SignUp") }}</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showModal" class="store-login-backdrop fixed inset-0 z-40 bg-black opacity-25"></div>
</template>

<script>
import axios from "axios";
// import { ref } from 'vue'
import {
  Disclosure,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";
import { notify } from "@kyvg/vue3-notification";
import {
  MagnifyingGlassIcon,
  BuildingStorefrontIcon,
  MapPinIcon,
  ShoppingBagIcon,
  Squares2X2Icon,
  UserCircleIcon,
} from "@heroicons/vue/24/outline";
import CartPopover from "./CartPopover.vue";
// const navigation = [
//   { name: 'Home', href: '/', current: false },
//   { name: 'Vendors', href: '/vendors', current: false },
//   // { name: 'Pharmacy', href: '/pharmacies', current: false }
// ]

export default {
  data() {
    return {
      isLoggedIn: false,
      vendors: null,
      user: null,
      settings: null,
      showModal: false,
      search: null,
      products: null,
      currency: null,
      base_url: this.$store.state.baseUrl,
      details: {
        email: null,
        password: null,
      },
      message: null,
      locationOpen: false,
      locationLabel: localStorage.getItem("selectedLocation") || "Select Location",
    };
  },
  components: {
    Disclosure,
    CartPopover,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    MagnifyingGlassIcon,
    BuildingStorefrontIcon,
    MapPinIcon,
    ShoppingBagIcon,
    Squares2X2Icon,
    UserCircleIcon,
  },
  // setup() {
  //   const open = ref(false)

  //   return {
  //     navigation,
  //     open,
  //   }
  // },

  mounted() {
    this.$store.dispatch("fetchSettings").then(() => {
      this.settings = this.$store.state.settings;
      // let mapKey = this.settings.strings.google_maps_key
      // console.log(this.settings)
    });

    if (localStorage.getItem("authToken")) {
      this.isLoggedIn = true;
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    let selectedLanguage = localStorage.getItem('selectedLanguage');
    const headers = {
      lang: selectedLanguage,
    };
    
    axios
      .get(this.base_url + "api/vendor/types", { headers })
      .then((response) => {
        this.vendors = response.data;
      })
      .catch((error) => console.log(error));
  },

  computed: {
    cartItemCount() {
      return this.$store.getters.count;
    },
  },

  methods: {
    getSearchResult() {
      if (!this.search || !this.search.trim()) return;
      this.$router.push({ name: "DefaultSearch", params: { slug: this.search } });
    },
    setLocation(place) {
      if (!place) return;
      this.locationLabel = place.name || place.formatted_address;
      localStorage.setItem("selectedLocation", this.locationLabel);
      this.locationOpen = false;
    },
    logout() {
      localStorage.removeItem("authToken");
      localStorage.removeItem("phone");
      localStorage.removeItem("user");
      this.$router.push("/");
      window.location.href = "/login";
    },

    randomString(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~$^*()";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    toggleModal: function () {
      this.showModal = !this.showModal;
    },

    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },

    login() {
      // this.$store.commit('loading', true)
      // if (this.terms == false) {

      // }
      axios
        .post(this.base_url + "api/login", this.details)
        .then((response) => {
          this.showModal = !this.showModal;
          if (
            this.settings.strings.otpGateway == "Firebase" &&
            this.settings.strings.enableOTPLogin == "1"
          ) {
            localStorage.setItem(
              "phone",
              JSON.stringify(response.data.user.phone)
            );
            this.$router.push("/firebase/verify/");
          } else if (
            this.settings.strings.otpGateway != "None" &&
            this.settings.strings.enableOTPLogin == "1"
          ) {
            localStorage.setItem(
              "phone",
              JSON.stringify(response.data.user.phone)
            );
            this.$router.push("/verify/");
          } else {
            localStorage.setItem("authToken", response.data.token);
            localStorage.setItem("user", JSON.stringify(response.data.user));
            notify({
              type: "success",
              title: "Login",
              text: response.data.message,
            });
            window.location.href = "/";
          }
        })
        .catch((error) => {
          if (error.response) {
            this.message = error.response.data.message;
            // notify({
            //   type: 'error',
            //   title: 'Account Error',
            //   text: error.response.data.message,
            //   duration: 3000
            // })
          }
        })
        .finally(() => this.$store.commit("loading", false));
    },
  },
};
</script>

<style scoped>
.store-nav {
  background: rgba(255, 255, 255, 0.96);
  border-color: var(--color-line);
  box-shadow: 0 4px 20px rgba(32, 52, 43, 0.035);
  backdrop-filter: blur(16px);
}

.store-nav-inner {
  padding-right: 1rem;
  padding-left: 1rem;
}

.store-top-row {
  display: grid;
  min-height: 5rem;
  grid-template-columns: auto minmax(9rem, 13rem) minmax(18rem, 1fr) auto;
  grid-template-areas: "brand location search actions";
  align-items: center;
  gap: 1.2rem;
}

.store-brand {
  grid-area: brand;
}

.store-brand-name {
  color: var(--color-ink);
  font-family: var(--font-display);
  font-size: 1.35rem;
}

.store-actions {
  grid-area: actions;
  gap: 0.35rem;
}

.store-search {
  grid-area: search;
  width: 100%;
  max-width: 52rem;
  margin: 0;
  min-height: 3.15rem;
  padding: 0.3rem 0.35rem 0.3rem 0.85rem;
  border: 1px solid #d8e2da;
  border-radius: 0.7rem;
  background: #fff;
  box-shadow: 0 2px 8px rgba(29, 41, 57, 0.035);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.store-search:focus-within {
  border-color: var(--color-coral);
  box-shadow: 0 0 0 3px rgba(82, 126, 96, 0.12);
}

.store-search-leading {
  width: 1.25rem;
  height: 1.25rem;
  flex: 0 0 auto;
  color: #5c7162;
  stroke-width: 1.8;
}

.store-location {
  position: relative;
  grid-area: location;
  min-width: 0;
}

.store-location-caption {
  display: block;
  margin-bottom: 0.15rem;
  color: var(--color-muted);
  font-size: 0.63rem;
  font-weight: 700;
}

.store-location-button {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.45rem;
  padding: 0;
  border: 0;
  color: var(--color-ink);
  background: transparent;
  font-size: 0.78rem;
  font-weight: 800;
  text-align: left;
  cursor: pointer;
}

.store-location-button > svg {
  width: 1rem;
  height: 1rem;
  flex: 0 0 auto;
  object-fit: contain;
}

.store-location-button > span:nth-child(2) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.store-location-chevron {
  width: 0.45rem;
  height: 0.45rem;
  margin-left: 0.1rem;
  border-right: 1.5px solid var(--color-muted);
  border-bottom: 1.5px solid var(--color-muted);
  color: var(--color-muted);
  transform: translateY(-0.1rem) rotate(45deg);
}

.store-outline-icon {
  width: 1.35rem;
  height: 1.35rem;
  flex: 0 0 auto;
  color: #355346;
  stroke-width: 1.75;
}

.store-location-popover {
  position: absolute;
  z-index: 80;
  top: calc(100% + 0.8rem);
  left: 0;
  width: min(21rem, calc(100vw - 2rem));
  padding: 1rem;
  border: 1px solid var(--color-line);
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 16px 40px rgba(32, 52, 43, 0.16);
}

.store-location-popover p {
  margin-bottom: 0.6rem;
  color: var(--color-ink);
  font-size: 0.78rem;
  font-weight: 800;
}

.store-location-input {
  display: block;
  width: 100%;
  height: 2.8rem;
  padding: 0 0.75rem;
  border: 1px solid var(--color-line);
  border-radius: 0.5rem;
  background: var(--color-paper);
  font-size: 0.78rem;
}

.store-category-nav {
  display: flex;
  min-height: 3.3rem;
  align-items: stretch;
  gap: 1.6rem;
  overflow-x: auto;
  border-top: 1px solid #f0f2ef;
  scrollbar-width: none;
}

.store-category-nav::-webkit-scrollbar {
  display: none;
}

.store-category-link {
  position: relative;
  display: inline-flex;
  min-width: max-content;
  align-items: center;
  gap: 0.45rem;
  color: #637168;
  font-size: 0.8rem;
  font-weight: 700;
  text-decoration: none;
}

.store-category-icon {
  width: 1.2rem;
  height: 1.2rem;
  flex: 0 0 auto;
  color: #58705f;
  stroke-width: 1.7;
}

.store-category-all-icon {
  width: 1.1rem;
  height: 1.1rem;
  stroke-width: 1.8;
  color: var(--color-coral);
}

.store-category-link.is-active,
.store-category-link:hover {
  color: var(--color-green);
}

.store-category-link.is-active::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--color-coral);
  content: "";
}

.store-search-input {
  min-width: 0;
  color: var(--color-ink);
  background: transparent;
  box-shadow: none;
  appearance: none;
}

.store-search-input:focus {
  outline: 0;
  box-shadow: none;
}

.store-search-button {
  flex: 0 0 auto;
  justify-content: center;
  min-width: 5rem;
  height: 2.45rem;
  padding: 0 0.85rem;
  border: 0;
  border-radius: 0.5rem;
  color: #fff;
  background: var(--color-green-dark);
  font-size: 0.78rem;
  font-weight: 600;
  transition: background 150ms ease;
}

.store-search-button:hover {
  background: var(--color-green);
}

.store-icon-button,
.store-cart-link {
  align-items: center;
  justify-content: center;
  min-width: 2.65rem;
  min-height: 2.65rem;
  color: var(--color-ink);
  background: var(--color-paper);
}

.store-login-overlay {
  z-index: 70;
  padding: 1rem;
  background: rgba(26, 42, 34, 0.42);
  backdrop-filter: blur(5px);
}

.store-login-dialog {
  overflow: hidden;
  border: 1px solid var(--color-line);
  border-radius: 1rem;
  box-shadow: 0 24px 80px rgba(32, 52, 43, 0.2);
}

.store-login-backdrop {
  display: none;
}

@media (max-width: 640px) {
  .store-nav-inner {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }

  .store-top-row {
    min-height: auto;
    grid-template-columns: minmax(5rem, auto) minmax(6rem, 1fr) auto;
    grid-template-areas:
      "brand location actions"
      "search search search";
    gap: 0.4rem 0.55rem;
    padding-top: 0.45rem;
    padding-bottom: 0.5rem;
  }

  .store-search {
    min-height: 2.7rem;
  }

  .store-search-button {
    min-width: 4.25rem;
    height: 2.15rem;
    padding: 0 0.6rem;
    font-size: 0.72rem;
  }

  .store-category-nav {
    min-height: 2.9rem;
    gap: 1.25rem;
    margin-right: -0.75rem;
    margin-left: -0.75rem;
    padding: 0 0.75rem;
  }

  .store-search-input {
    padding-right: 0.35rem;
    padding-left: 0.55rem;
    font-size: 0.7rem;
  }

  .store-brand-name {
    max-width: 5.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .store-icon-button,
  .store-cart-link {
    min-width: 2.25rem;
    min-height: 2.25rem;
    padding: 0.35rem;
  }

  .store-location-caption {
    font-size: 0.58rem;
  }

  .store-location-button {
    font-size: 0.68rem;
  }
}
</style>
